import {LoggerService, LogLevel} from './logger-service';


/**
 * A component with logging capabilities.
 *
 */
export class LoggedComponent {

  protected componentName = this.constructor.name;

  constructor(protected logger: LoggerService) {
    this.logger.log(this.componentName, `New instance ${this.componentName} created`);
  }

  public setLogLevel(newLogLevel: LogLevel) {
    this.logger.setComponentLogLevel(this.componentName, newLogLevel);
  }

  public error(...data: any[]) {
    this.logger.error(this.componentName, ...data);
  }

  public warning(...data: any[]) {
    this.logger.warning(this.componentName, ...data);
  }

  public info(...data: any[]) {
    this.logger.info(this.componentName, ...data);
  }


  protected log(...data: any[]) {
    this.logger.log(this.componentName, ...data);
  }

  public debug(...data: any[]) {
    this.logger.debug(this.componentName, ...data);
  }
}
